import { formatInterviewSchedule } from 'features/sendouts/common/utils';

const EMPTY_VALUE = '---';

export const formatInterviewDate = ({ startTimestamp, endTimestamp, interviewTimeZone } = {}) =>
  formatInterviewSchedule({ startTimestamp, endTimestamp, timezone: interviewTimeZone }) ||
  EMPTY_VALUE;
